import { decodeText } from '@aytm/app/stats/lib/util/helpers'
import { removeLogicFromText, removeTagsFromText } from '@aytm/app/stats/page/components/lib/utils'

// svg:title is a textContent sink — decode + strip logic/tags so an "&amp;" name
// shows as "&" not literally
export const sectionTitle = (text = '') =>
  decodeText(removeTagsFromText(removeLogicFromText(text || ''), { decode: true }))
